import { styled } from '@mui/material/styles';

const StyledPrimaryFooter = styled('div')`
  font-size: 1rem;
  background: var(--primary-color);
  padding: 1rem 2rem;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: left;
  }
`;

export default StyledPrimaryFooter;
